export const allFieldsBodyTemplate = (rowData:any, field: string, criteria: string, formatDate?: any) => {
  return (
    <div
      style={{
        boxShadow : (!rowData[criteria] && field !== 'actions')
          ? 'var(--backgroundColor) 0px 0px 0px 500px'
          : 'none',
        background: (!rowData[criteria] && field !== 'actions')
          ? 'var(--backgroundColor)'
          : 'none',
      }}
    >
      {(field === "createdat" || field === "modifiedat") ? formatDate(rowData[field]) : rowData[field]}
    </div>)
};
